import { render } from "./policyData.vue?vue&type=template&id=46dd3db4&scoped=true"
import script from "./policyData.vue?vue&type=script&lang=js"
export * from "./policyData.vue?vue&type=script&lang=js"

import "./policyData.vue?vue&type=style&index=0&id=46dd3db4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46dd3db4"]])

export default __exports__